import React from "react";
import { Play, Check, Plus, Trash } from "@phosphor-icons/react";

const STAGE_META = {
  pending: { cls: "bg-slate-100 text-slate-600 border-slate-300", label: "Pending" },
  in_progress: { cls: "bg-cyan-50 text-cyan-700 border-cyan-300", label: "In progress" },
  done: { cls: "bg-emerald-50 text-emerald-700 border-emerald-300", label: "Done" },
};

export function JobStagesCard({
  stages, users, techs, currentUserId, canAssignDirect, busy,
  newStageName, setNewStageName, newStageAssignee, setNewStageAssignee,
  onAddStage, onPatchStage, onDeleteStage,
}) {
  if (stages.length === 0 && !canAssignDirect) return null;
  return (
    <div className="rmms-card p-5" data-testid="job-stages-card">
      <div className="overline mb-3">Stages</div>
      {stages.length === 0 ? (
        <div className="text-sm text-slate-400 mb-3">No stages yet. Split the job into stages and assign each to a different tech.</div>
      ) : (
        <ol className="space-y-2 mb-3" data-testid="job-stages-list">
          {stages.map((s) => {
            const u = users.find((x) => x.id === s.assigned_to_id);
            const meta = STAGE_META[s.status] || { cls: "bg-slate-100", label: s.status };
            const isMyStage = s.assigned_to_id === currentUserId;
            return (
              <li key={s.id} data-testid={`stage-${s.id}`} className="flex items-start gap-2 p-2 border border-slate-200 rounded-sm">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="text-sm font-medium truncate">{s.name}</div>
                    <span className={`text-[10px] font-heading uppercase tracking-wider font-semibold border rounded-sm px-1.5 py-0.5 ${meta.cls}`}>{meta.label}</span>
                  </div>
                  <div className="text-[11px] text-slate-500 mt-0.5">{u?.name || "Unassigned"}</div>
                </div>
                <div className="flex gap-1">
                  {isMyStage && s.status === "pending" && (
                    <button data-testid={`stage-start-${s.id}`} onClick={() => onPatchStage(s.id, { status: "in_progress" })}
                      className="h-6 w-6 inline-flex items-center justify-center border border-slate-200 rounded-sm hover:bg-cyan-50" title="Start">
                      <Play size={10} weight="fill" />
                    </button>
                  )}
                  {isMyStage && s.status === "in_progress" && (
                    <button data-testid={`stage-done-${s.id}`} onClick={() => onPatchStage(s.id, { status: "done" })}
                      className="h-6 w-6 inline-flex items-center justify-center border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-sm" title="Mark done">
                      <Check size={10} weight="bold" />
                    </button>
                  )}
                  {canAssignDirect && (
                    <button data-testid={`stage-delete-${s.id}`} onClick={() => onDeleteStage(s.id)}
                      className="h-6 w-6 inline-flex items-center justify-center border border-slate-200 rounded-sm hover:bg-rose-50 hover:text-rose-600">
                      <Trash size={10} />
                    </button>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      )}
      {canAssignDirect && (
        <div className="border-t border-slate-100 pt-3 space-y-2">
          <div className="grid grid-cols-1 gap-2">
            <input value={newStageName} onChange={(e) => setNewStageName(e.target.value)} data-testid="job-stage-name-input" placeholder="Stage name (e.g. Inspect pipe)" className="rmms-input h-8 text-sm" />
            <select value={newStageAssignee} onChange={(e) => setNewStageAssignee(e.target.value)} data-testid="job-stage-assignee-select" className="rmms-input h-8 text-sm">
              <option value="">(unassigned)</option>
              {techs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <button data-testid="job-stage-add" onClick={onAddStage} disabled={busy || !newStageName.trim()}
            className="w-full h-8 text-xs inline-flex items-center justify-center gap-1 border border-slate-200 rounded-sm hover:bg-slate-50 disabled:opacity-50">
            <Plus size={10} weight="bold" /> Add stage
          </button>
        </div>
      )}
    </div>
  );
}
